<template>
  <div class="row age-range-input">
    <span v-if="firstText" class="align-self-start pt-2">{{ firstText }}</span>

    <InputLabel
      class="col-4"
      v-model="localAgeFrom"
      :label="fromLabel"
      :placeholder="fromPlaceholder"
      type="number"
      min="1"
      :disabled="disabled"
      :required="requiredInput"
    />
    <span v-if="unitLabel" class="align-self-center pt-2">{{ unitLabel }}</span>

    <span v-if="secondText" class="align-self-start pt-2">{{ secondText }}</span>
    <InputLabel
      class="col-4"
      v-model="localAgeTo"
      :label="toLabel"
      :placeholder="toPlaceholder"
      type="number"
      min="1"
      :disabled="disabled"
      :required="requiredInput"
    />
    <span v-if="unitLabel"  class="align-self-center pt-2">{{ unitLabel }}</span>
  </div>
</template>

<script>
import InputLabel from './InputLabel.vue';
export default {
  components: {InputLabel},
  name: "RangeInput",
  props: {
    ageFrom: {
      type: [String, Number],
      required: true,
    },
    ageTo: {
      type: [String, Number],
      required: true,
    },
    fromLabel: {
      type: String,
      default: "",
    },
    toLabel: {
      type: String,
      default: "",
    },
    fromPlaceholder: {
      type: String,
      default: "",
    },
    toPlaceholder: {
      type: String,
      default: "",
    },
    unitLabel: {
      type: String,
      default: null,
    },
    firstText: {
      type: String,
      default: null
    },
    secondText: {
      type: String,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    requiredInput: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      localAgeFrom: this.ageFrom,
      localAgeTo: this.ageTo,
    };
  },
  watch: {
    localAgeFrom(newVal) {
      this.$emit("update:ageFrom", newVal);
    },
    localAgeTo(newVal) {
      this.$emit("update:ageTo", newVal);
    },
    ageFrom(newVal) {
      this.localAgeFrom = newVal;
    },
    ageTo(newVal) {
      this.localAgeTo = newVal;
    },
  },
};
</script>

<style scoped>
.age-range-input {
  display: flex;
  align-items: center;
}
</style>
